import CheckBoxSelected from "icons/checkbox-selected.svg"
import CheckBox from "icons/checkbox.svg"
import { clone } from "rambdax"
import { useEffect, useState } from "react"
import { Popup } from "react-vant"
import { cls } from "reactutils"
import SearchFooter from "./SearchFooter"

type SearchMoreDrawerProps = any

const PopupStyle = {
  width: 320,
  height: "100%",
}

export default function SearchMoreDrawer({
  visible,
  title,
  labelKey,
  value: initValue,
  list,
  onClose,
  onChange,
}: SearchMoreDrawerProps) {
  const [activeLeftIndex, setActiveLeftIndex] = useState(0)
  const [value, setValue] = useState<Array<any>>([...initValue])
  const activeLeftSysNo = list?.[activeLeftIndex]?.sysNo

  useEffect(() => {
    setValue([...initValue])
  }, [initValue])

  useEffect(() => {
    if (visible) {
      setActiveLeftIndex(0)
    }
  }, [visible])

  function isActive({
    sysNo,
    isUnlimited,
  }: {
    sysNo: any
    isUnlimited?: boolean
  }) {
    const isIncludes = value.includes(sysNo)
    if (isUnlimited) {
      return isIncludes
    } else {
      // 如果已经勾选了不限，就不高亮选中显示
      return isIncludes && !value.includes(activeLeftSysNo)
    }
  }

  function handleClickCheckBox(sysNo: any) {
    const draftValue = clone(value)
    const indexRightSysNo = value.findIndex(
      (selectSysNo) => selectSysNo === sysNo,
    )
    const indexLeftSysNo = value.findIndex(
      (selectSysNo) => selectSysNo === activeLeftSysNo,
    )
    if (indexRightSysNo === -1) {
      // 该二级分类没有被勾选状态
      if (indexLeftSysNo !== -1) {
        // 如果"不限"已被勾选,取消"不限"的勾选
        draftValue.splice(indexLeftSysNo, 1)
      }
      draftValue.push(sysNo)
    } else {
      // 该二级分类已经是被勾选状态
      if (indexLeftSysNo !== -1) {
        /**
         * 如果"不限"也被勾选了，
         * 将其他二级分类和"不限"都取消勾选，
         * 然后将点击的二级分类勾选
         */
        clearOtherCheckBox(draftValue)
        draftValue.splice(indexLeftSysNo, 1)
        draftValue.push(sysNo)
      } else {
        draftValue.splice(indexRightSysNo, 1)
      }
    }
    setValue(draftValue)
  }

  function handleClickUnlimited() {
    const draftValue = clone(value)
    const index = value.findIndex(
      (selectSysNo) => selectSysNo === activeLeftSysNo,
    )
    if (index === -1) {
      // 清除该分类下的二级分类，选中"不限"

      clearOtherCheckBox(draftValue)
      draftValue.push(activeLeftSysNo)
    } else {
      // 取消勾选"不限"
      draftValue.splice(index, 1)
    }
    setValue(draftValue)
  }

  function clearOtherCheckBox(draftValue: Array<any>) {
    const rightList = list?.[activeLeftIndex]?.children
    rightList?.forEach((rightItem) => {
      const index = draftValue.findIndex(
        (selectSysNo) => selectSysNo === rightItem.sysNo,
      )
      if (index !== -1) {
        draftValue.splice(index, 1)
      }
    })
  }

  return (
    <Popup
      visible={visible}
      onClose={onClose}
      position="right"
      style={PopupStyle}
      transition="simple-right-transition"
    >
      <div className="drawerContentWrap">
        <div className="conditionTitle">选择{title}</div>
        <div className="conditionWrap">
          <div className="leftWrap">
            {list?.map((leftItem, leftIndex) => (
              <div
                onClick={() => {
                  setActiveLeftIndex(leftIndex)
                }}
                key={leftIndex}
                className={cls(
                  "leftItem",
                  activeLeftIndex === leftIndex && "active",
                )}
              >
                {leftItem[labelKey]}
              </div>
            ))}
          </div>
          <div className="rightWrap">
            <div
              className="rightItem"
              onClick={() => {
                handleClickUnlimited()
              }}
            >
              <div
                className={cls(
                  "rightItemTxt",
                  isActive({ sysNo: activeLeftSysNo, isUnlimited: true }) &&
                    "activeTxt",
                )}
              >
                不限
              </div>
              {isActive({ sysNo: activeLeftSysNo, isUnlimited: true }) && (
                <span className="checkIcon"></span>
              )}
            </div>
            {list?.[activeLeftIndex]?.children?.map((rightItem, rightIndex) => (
              <div
                onClick={() => {
                  handleClickCheckBox(rightItem.sysNo)
                }}
                key={rightIndex}
                className="rightItem"
              >
                <div
                  className={cls(
                    "rightItemTxt",
                    isActive({ sysNo: rightItem.sysNo, isUnlimited: false }) &&
                      "activeTxt",
                  )}
                >
                  {rightItem[labelKey]}
                </div>
                <span className="checkBox">
                  {isActive({ sysNo: rightItem.sysNo, isUnlimited: false }) ? (
                    <CheckBoxSelected />
                  ) : (
                    <CheckBox />
                  )}
                </span>
              </div>
            ))}
          </div>
        </div>
        <SearchFooter
          onReset={() => {
            setValue([])
          }}
          onConfirm={() => {
            onChange(value)
            onClose()
          }}
        ></SearchFooter>
      </div>
      <style jsx>{`
        :global .more-popup {
          background: none;
        }
        .drawerContentWrap {
          display: flex;
          height: 100vh;
          flex-direction: column;
          box-sizing: border-box;
        }

        .conditionTitle {
          font-size: 15px;
          color: #262626;
          line-height: 13px;
          padding: 25px 0 24px 22px;
          border-bottom: 1px solid #ededed;
          font-weight: bold;
        }

        .conditionWrap {
          flex: 1;
          overflow-y: auto;
          display: flex;
        }

        .leftWrap {
          flex: 0 0 120px;
          background-color: #f5f5f5;
          overflow-y: auto;
        }

        .leftItem {
          height: 50px;
          box-sizing: border-box;
          padding: 15px 5px 15px 22px;
          font-size: 14px;
          color: #262626;
        }

        .leftItem.active {
          background-color: #fff;
          color: var(--primaryColor);
        }

        .rightWrap {
          flex: 0 0 200px;
          overflow-y: auto;
        }

        .rightItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 17px 24px 13px 24px;
        }

        .rightItemTxt {
          font-size: 14px;
          color: #262626;
          padding-right: 8px;
        }

        .activeTxt {
          color: var(--primaryColor);
        }

        .checkBox {
          height: 16px;
          flex: 0 0 16px;
        }

        .checkBox :global(svg path) {
          fill: var(--primaryColor);
        }

        .checkIcon {
          width: 17px;
          height: 9px;
          border-left: 2px solid var(--primaryColor);
          border-bottom: 2px solid var(--primaryColor);
          transform: rotate(-45deg);
          display: inline-block;
        }
      `}</style>
    </Popup>
  )
}
